<template>
  <v-app>
    <v-app-bar
      app
      color="#06497D"
      dark
    >
      <div class="d-flex align-center">
        <v-img
          alt="Vuetify Logo"
          class="shrink mr-2"
          contain
          src="../assets/Qlogo.png"
          transition="scale-transition"
          width="40"
        />

        <a style="text-decoration: none;color:white" :href="baseADMIN+'/line_allUser.html'"><p class="text-h5 mb-0">QHR人資打卡</p></a>
      </div>

      <v-spacer></v-spacer>
      <div v-bind:class="ctrlCls">
      <!-- <v-btn
          v-bind:href="'./noticeset?'+ queryString"
          class="d-none d-md-flex"
          target="_self"
          text
        >
          <span class="mr-2">打卡提醒設定</span>
          <v-icon>mdi-clock-time-four-outline</v-icon>
        </v-btn> -->
      <v-btn
        v-bind:href="'./Map?'+ queryString"
        class="d-none d-md-flex"
        target="_self"
        text
      >
        <span class="mr-2">GPS打卡設定</span>
        <v-icon>mdi-flag</v-icon>
      </v-btn>
      <v-btn
        v-bind:href="'./Wifi?'+ queryString"
        class="d-none d-md-flex"
        target="_self"
        text
      >
        <span class="mr-2">WIFI打卡設定</span>
        <v-icon>mdi-wifi</v-icon>
      </v-btn>
      <v-menu
        transition="slide-y-transition"
        bottom
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="d-block d-md-none"
            color="#06497D"
            dark
            v-bind="attrs"
            v-on="on"
          >
          <v-icon>mdi-menu</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item v-bind:href="'./Map?'+ queryString">
            <v-list-item-title>GPS打卡</v-list-item-title>
            <v-icon>mdi-flag</v-icon>
          </v-list-item>
          <v-list-item v-bind:href="'./Wifi?'+ queryString">
            <v-list-item-title>WIFI打卡</v-list-item-title>
            <v-icon>mdi-wifi</v-icon>
          </v-list-item>
          <!-- <v-list-item v-bind:href="'./noticeset?'+ queryString">
            <v-list-item-title>打卡提醒</v-list-item-title>
            <v-icon>mdi-clock-time-four-outline</v-icon>
          </v-list-item> -->
        </v-list>
      </v-menu>
      </div>
    </v-app-bar>

    <v-main style="height: 100vh;">
      <!-- <router-view baseADMIN="https://admin.qhr.app/" baseAPI="https://erp.qhr.app" baseLINE="https://test.linebot.qhr.app/" baseURL="https://test.punch.qhr.app/" v-on:menuShow="menuShow"/> -->
      <!-- <router-view baseADMIN="https://80125262admin.qhr.app/" baseAPI="https://80125262erp.qhr.app" baseLINE="https://80125262linebot.qhr.app/" baseURL="https://80125262punch.qhr.app/" v-on:menuShow="menuShow"/> -->
      <!-- <router-view baseADMIN="https://12994073admin.qhr.app/" baseAPI="https://12994073erp.qhr.app" baseLINE="https://12994073linebot.qhr.app/" baseURL="https://12994073punch.qhr.app/" v-on:menuShow="menuShow"/> -->
      <router-view :tax="$route.params.tax" :baseADMIN="baseADMIN" :baseAPI="'https://erp.qhr.app/'+$route.params.tax" :baseLINE="'https://test.linebot.qhr.app/'+$route.params.tax" :baseURL="'https://test.punch.qhr.app/'+$route.params.tax" v-on:menuShow="menuShow"/>
      <!-- <router-view baseADMIN="https://50955705admin.qhr.app/" baseAPI="https://50955705erp.qhr.app" baseLINE="https://50955705linebot.qhr.app/" baseURL="https://50955705punch.qhr.app/" v-on:menuShow="menuShow"/> -->
      <!-- <router-view baseADMIN="https://56623731admin.qhr.app" baseAPI="https://56623731erp.qhr.app" baseLINE="https://56623731linebot.qhr.app" baseURL="https://56623731punch.qhr.app" v-on:menuShow="menuShow"/> -->
      <!-- <router-view baseADMIN="http://114.35.38.159:9527" baseAPI="http://114.35.38.159:1202" baseLINE="https://test.qsystem.com.tw" baseURL="https://testpunchin.qsystem.com.tw" v-on:menuShow="menuShow"/> -->
      <!-- <router-view baseLINE="https://testlinepunch.pokerfun.com.tw/" baseURL="https://testpunchinweb.pokerfun.com.tw/" v-on:menuShow="menuShow"/> -->
      <!-- <router-view baseLINE="https://qsystem.com.tw/" baseURL="https://punchin.qsystem.com.tw/" v-on:menuShow="menuShow"/> -->
    </v-main>
  </v-app>
</template>

<script>
export default {
  components: {
  },

  data: () => ({
    baseADMIN:"https://admin.qhr.app/",
    btnWifi:false,
    btnMap:false,
    queryString:"",
    ctrlCls:"d-flex",
  }),
  methods:{
    menuShow: function (data) {
      console.log("子",data);
        // childValue就是子组件传过来的值
        if(data == false){
          this.ctrlCls = "d-none";
        }
    }
  },
  beforeCreate: function(){
    console.log('beforeCreate')
  },
  created: function(){
    console.log('created')
  },
  beforeMount: function(){
    console.log('beforeMount')
  },
  mounted: function(){
    console.log('mounted')
    let name = this.$route.name;
    switch(name){
      case "Map":
        this.btnMap = true;
        break;
      case "Wifi":
        this.btnWifi = true;
        break;
    }
    let query = this.$route.query;
    let keys = Object.keys(query);
    for(let i = 0;i<keys.length;i++){
      this.queryString += (keys[i]+"=");
      this.queryString += (query[keys[i]]);
      if(i!=keys.length-1){
        this.queryString += "&";
      }
    }
  }
};
</script>





